var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"Component",staticClass:"a-tag",class:[`a-tag--theme-${_vm.theme}`, { 'a-tag--hoverable': _vm.isHoverable }],attrs:{"to":_vm.to}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }